import { createFileRoute } from "@tanstack/react-router";
import { pricingFaqs } from "@/lib/data/pricing-data";
import { generateFAQSchema } from "@/lib/utils/schema.utils";
import { generateSeo } from "@/lib/utils/seo";

export const Route = createFileRoute("/_main/pricing")({
	head: () =>
		generateSeo({
			title:
				"Transparent Pricing | Web Design & Development Packages | CraftLayer",
			description:
				"Clear, competitive pricing for premium web services. Explore our packages for Web Design, Next.js Development, and SEO to fit your business goals.",
			url: "/pricing",
			keywords: [
				"web design pricing",
				"development packages",
				"SEO pricing",
				"CraftLayer rates",
				"service costs",
			],
		}),
	loader: async () => {
		const faqs = pricingFaqs;
		const faqSchema = generateFAQSchema(faqs);
		return { faqs, faqSchema };
	},
});
